import type {Dayjs} from 'dayjs'
import {Time} from '@package/shared'

export const formatIsoTime = (date: Dayjs): Time => {
  return Time.parse(date.format('HH:mm'))
}
